/* --- import Styles ----*/
import { BtnWrapper, HeroHomeWrapper, HeroLeft } from 'src/components/Hero/elements';
import { Button, MobileApplyBTN } from 'src/components/Button';
import { HeaderDescription, HeaderTitle } from 'src/components/Typography';
import { LatestsPosts, OnlineOnsite, StackTech } from 'src/components/Home';
import { useEffect, useState } from 'react';

import { Founders } from '../components/Founders/index';
/* --- import Components ----*/
import Layout from 'src/components/Layout';
import { MainVideo } from 'src/components/Projects';
import ModalForm from 'src/components/Modal/ModalFormSyllabus';
import { PartnersSection } from 'src/components/Partners';
// eslint-disable-next-line
import React from 'react';
import { RecruitersSection } from 'src/components/Partners';
import { Section } from 'src/components/Section';
// import { PodcastSection } from 'src/components/Podcast';
import { Testimonials } from '../components/Bootcamp/Testimonials/';
import { TopbarStaticSpace } from 'src/components/Topbar';
import { graphql } from 'gatsby';
/* --- import Media Queries ----*/
import { mediaQueries } from 'src/style/breakpoints';
import colors from 'src/style/colors';

const HomePage = ({
  data,
  data: {
    allMarkdownRemark: { edges },
  },
  location,
  // pageContext: { nextSessions },
}) => {
  // const [fullTimeSesssions, setFullTimeSessions] = useState([]);
  // const [partTimeSesssions, setPartTimeSessions] = useState([]);
  const [buttonVisible, setButtonVisible] = useState(false);

  const [isModalFormOpen, setIsModalFormOpen] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [values, setValues] = useState();

  // const initSessionsState = useCallback(() => {
  //   let newFullTimeSessions = [];
  //   let newPartTimeSessions = [];
  //   nextSessions.map((item, index) => {
  //     if (item.format && item.format === 'full-time') {
  //       newFullTimeSessions.push(item, index);
  //       return newFullTimeSessions;
  //     } else if (item.format && item.format === 'part-time') {
  //       newPartTimeSessions.push(item, index);
  //       return newPartTimeSessions;
  //     } else {
  //       return null;
  //     }
  //   });
  //   setFullTimeSessions(newFullTimeSessions);
  //   setPartTimeSessions(newPartTimeSessions);
  // }, [nextSessions]);

  useEffect(() => {
    // initSessionsState();
    const handleScroll = () => {
      if (global.window && window.pageYOffset >= 150) {
        return setButtonVisible(true);
      } else {
        return setButtonVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  edges = edges.filter((edge) => edge.node.frontmatter.published === true).slice(0, 6);

  return (
    <Layout
      pathname={location.pathname}
      businessType="B2C|B2B"
      pageName="Homepage"
      pageType="homepage"
      metaTitle="Formation Concepteur Développeur d'Applications | Le Reacteur"
      metaDescription="Le Reacteur est la première formation Concepteur Développeur d'Applications JavaScript intensive en France. À temps plein ou en alternance, apprenez à coder !"
      metaVideo="https://www.youtube.com/embed/59XH_-eMQhE"
    >
      <TopbarStaticSpace />
      {/* HERO HOME */}
      <Section
        theme="primary"
        home
        hero
        css={{
          [mediaQueries.desktopUp]: {
            minHeight: '700px',
          },
          [mediaQueries.bigDesktopUp]: {
            maxHeight: '800px',
          },
        }}
      >
        <HeroHomeWrapper>
          <HeroLeft>
            <HeaderTitle>
              <p
                css={{
                  [mediaQueries.phoneOnly]: {
                    display: 'none',
                  },
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'none',
                  },
                  [mediaQueries.tabletLandscapeUp]: {
                    display: 'block',
                  },
                  [mediaQueries.desktopUp]: {
                    display: 'none',
                  },
                  [mediaQueries.mediumDesktopUp]: {
                    display: 'block',
                  },
                }}
              >
                Codez le futur : devenez Développeur{' '}
                <i
                  css={{
                    backgroundColor: colors.pink,
                    color: colors.white,
                    padding: '2px 8px',
                    /* transform: 'skewX(-15deg)', */
                    display: 'inline-block',
                  }}
                >
                  AI-Driven
                </i>
              </p>
              <p
                css={{
                  [mediaQueries.phoneOnly]: {
                    display: 'block',
                  },
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'block',
                  },
                  [mediaQueries.tabletLandscapeUp]: {
                    display: 'none',
                  },
                  [mediaQueries.desktopUp]: {
                    display: 'block',
                  },
                  [mediaQueries.mediumDesktopUp]: {
                    display: 'none',
                  },
                }}
              >
                Codez le futur :{' '}
                <br
                  css={{
                    display: 'none',
                    [mediaQueries.phoneOnly]: {
                      display: 'block',
                    },
                  }}
                />
                devenez Développeur{' '}
                <br
                  css={{
                    display: 'none',
                    [mediaQueries.phoneOnly]: {
                      display: 'block',
                    },
                  }}
                />{' '}
                <i
                  css={{
                    backgroundColor: colors.pink,
                    color: colors.white,
                    padding: '2px 8px',
                    display: 'inline-block',
                  }}
                >
                  AI-driven
                </i>
              </p>
            </HeaderTitle>
            <HeaderDescription
              css={{
                marginTop: 30,
                textAlign: 'center',
                [mediaQueries.desktopUp]: {
                  marginRight: 60,
                  textAlign: 'left',
                },
              }}
            >
              Depuis 2016, nous accompagnons des profils débutants et en reconversion vers les
              métiers du Développement Web et Mobile. Notre force : des projets concrets, un
              encadrement exigeant et l'intégration des technologies d'avenir comme l'intelligence
              artificielle pour coder rapidement et efficacement. Entrez dans l'ère <i>AI-driven</i>
              .
            </HeaderDescription>

            <BtnWrapper>
              <Button
                css={{
                  minWidth: 210,
                }}
                onClick={() => {
                  setIsModalFormOpen(!isModalFormOpen);
                }}
              >
                Recevoir nos programmes{' '}
                <br
                  css={{
                    [mediaQueries.tabletPortraitUp]: {
                      display: 'none',
                    },
                  }}
                />{' '}
                de formation
              </Button>
            </BtnWrapper>
            {isModalFormOpen && (
              <>
                <ModalForm
                  isOpen={isModalFormOpen}
                  onClose={() => {
                    setFormSuccess(false);
                    setIsModalFormOpen(false);
                  }}
                  formSuccess={formSuccess}
                  setFormSuccess={setFormSuccess}
                  values={values}
                  setValues={setValues}
                />
              </>
            )}
          </HeroLeft>
          <MainVideo
            mainThumbnail={data.heroimage.childImageSharp.fluid}
            link="https://www.youtube.com/embed/59XH_-eMQhE"
          />
        </HeroHomeWrapper>
      </Section>
      <OnlineOnsite />
      <StackTech theme="secondary" />
      {/* <DiplomaSection /> */}
      {/* <BestBootcamp /> */}
      <Founders
        portraitXavier={data.xavier.childImageSharp.gatsbyImageData}
        portraitFarid={data.farid.childImageSharp.gatsbyImageData}
        id="founders"
      />
      <PartnersSection theme="secondary" title="Ils nous soutiennent" />
      <Testimonials />
      <RecruitersSection theme="secondary" />
      {/* <PodcastSection /> */}
      <LatestsPosts data={edges} />
      {/* <InstagramFeed theme="secondary" /> */}
      <MobileApplyBTN buttonVisible={buttonVisible} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              '@context': 'https://schema.org',
              '@type': 'EducationalOrganization',
              name: 'Le Reacteur',
              alternateName: 'Le Reacteur - Coding Bootcamp & Alternance',
              url: 'https://www.lereacteur.io',
              logo: 'https://www.lereacteur.io/images/lereacteur_rond_violet.png',
              description: `Le Reacteur est la première formation Concepteur Développeur d'Applications JavaScript intensive à Paris. À temps plein ou en alternance, apprenez à coder !`,
              sameAs: [
                'https://www.facebook.com/LeReacteurIO',
                'https://twitter.com/LeReacteurIO',
                'https://linkedin.com/company/le-reacteur',
                'https://www.instagram.com/lereacteur.io',
              ],
              founders: [
                {
                  '@type': 'Person',
                  name: 'Xavier Colombel',
                  sameAs: [
                    'https://www.linkedin.com/in/xcolombel/',
                    /* 'https://medium.com/@XavierColombel', */
                    'https://github.com/XavierColombel',
                  ],
                },
                {
                  '@type': 'Person',
                  name: 'Farid Safi',
                  sameAs: [
                    'https://www.linkedin.com/in/faridsafi/',
                    'https://github.com/FaridSafi',
                  ],
                },
              ],
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                email: 'contact@lereacteur.io',
                url: 'https://www.lereacteur.io/contact/',
                areaServed: 'FR',
                availableLanguage: 'fr',
              },
            },
          ]),
        }}
      />
    </Layout>
  );
};

export const query = graphql`
  query {
    heroimage: file(relativePath: { eq: "2023_students6.jpg" }) {
      childImageSharp {
        fluid(quality: 80, maxWidth: 900) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    # imageFormationAdapte: file(relativePath: { eq: "image05.jpg" }) {
    #   childImageSharp {
    #     fluid(quality: 70, maxWidth: 550) {
    #       ...GatsbyImageSharpFluid_withWebp
    #     }
    #   }
    # }
    farid: file(relativePath: { eq: "2023_Farid.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 50, width: 300, placeholder: NONE)
      }
    }
    xavier: file(relativePath: { eq: "2023_Xavier.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 50, width: 300, placeholder: NONE)
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }, limit: 10) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "DD MMMM YYYY", locale: "fr")
            title
            author
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 970)
              }
            }
            tags
            preview
            published
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;

export default HomePage;
